(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("odometer"));
	else if(typeof define === 'function' && define.amd)
		define(["odometer"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("odometer")) : factory(root["Odometer"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition